/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { useMemo } from "react";
import { TViewComponent } from "../../../view/IView";
import { GettingStarted } from "./GettingStarted";
import { Layout } from "../../../ui/components/Layout/Layout";
import { GettingStartedMain } from "./components";

export const GettingStartedComponent: TViewComponent<GettingStarted> = ({ view }) => {
	const layoutState = useMemo(() => view.getLayout(), []);

	const renderComponent = (componentName: string) => {
		switch (componentName) {
			case "main":
				return <GettingStartedMain className="edt-base" view={view} />;
			default:
				return <p>Error: Undefined panel {componentName}.</p>;
		}
	};

	return <Layout state={layoutState} renderComponent={renderComponent} />;
};
